import axiosClient from './axios';

const getListCompany = async ({ page = 1, limit = 10, sort = 'arc', search = '' }: { page: number; limit: number; sort: 'arc' | 'des'; search: string }) => {
  try {
    return axiosClient.get(`/v1/get/company${`?page=${page}&limit=${limit}&sort=${sort}`}&userRole=employer&search=${search}`);
  } catch (error) { }
};

export { getListCompany };
